export default __webpack_public_path__ + "static/media/retailjpg.f34a97f5.jpg";